import { render, staticRenderFns } from "./ContactScreenContainer.vue?vue&type=template&id=56640993&scoped=true&"
import script from "./ContactScreenContainer.vue?vue&type=script&lang=js&"
export * from "./ContactScreenContainer.vue?vue&type=script&lang=js&"
import style0 from "./ContactScreenContainer.vue?vue&type=style&index=0&id=56640993&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56640993",
  null
  
)

export default component.exports